// extracted by css-extract-rspack-plugin
export default {"setupSubPage":"src-components-setup-SetupSubPage-module__setupSubPage-VjfA_i"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"setupSubPage\":\"src-components-setup-SetupSubPage-module__setupSubPage-VjfA_i\"}";
        // 1793732289282
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  